module.exports = __webpack_public_path__ + "static/media/mr_and_missis_smith.07e675a0.jpg";